import { render } from "./SuccessPayment.vue?vue&type=template&id=4a153864&scoped=true&ts=true"
import script from "./SuccessPayment.vue?vue&type=script&lang=ts"
export * from "./SuccessPayment.vue?vue&type=script&lang=ts"

import "./SuccessPayment.vue?vue&type=style&index=0&id=4a153864&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a153864"]])

export default __exports__